import { useState } from 'react'
import '../styles/profile.css'
import { useSelector } from 'react-redux'
import { type } from '@testing-library/user-event/dist/type'

const ProfileScreen = () => {
  const [firstName] = useState('John')
  const { userInfo, isAuthenticated } = useSelector((state) => state.auth);
  const nuInfo = Object.fromEntries(Object.entries(userInfo).filter(([key, value]) => key === "id" || key === "username" || key === "balance"))
  const ni = [nuInfo]
  // ni[ni.length] = nuInfo;
  // console.log(ni)

  return (
    <div className='unauthorized'>
      <figure>{userInfo.username.charAt(0).toUpperCase()}</figure>
      <span>
        Welcome <strong>{userInfo.username}!</strong> You can view this page because
        you're logged in
      </span>
      {ni.map((item) => (
        <div key = {item.id}>
          <p>
            id  : {item.id}
          </p><p>
            username : {item.username}
          </p><p>
            balance  : {item.balance}
          </p>
        </div>
        ))}
        
      
    </div>

  )
}

export default ProfileScreen
